import PickingSupplyForProductionCase from '@/models/PickingSupplyForProduction/PickingSupplyForProductionCase';

export default class PickingSupplyForProductionCaseFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.pickingSupplyForProductionId  = '';
		this.pickingSupplyForProductionWorkOrderSupply = '';
		this.pickingSupplyForProductionDetailId  = '';
		this.pickingSupplyForProductionDetailMaterialPart = '';
		this.controlCardId  = '';
		this.controlCardControlCardNumber = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.qty = '';
		this.remarkMultiple = '';
		this.documentStatusId  = '';
		this.documentStatusName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			pickingSupplyForProductionId : '0',
			pickingSupplyForProductionWorkOrderSupply : '0',
			pickingSupplyForProductionDetailId : '0',
			pickingSupplyForProductionDetailMaterialPart : '0',
			controlCardId : '0',
			controlCardControlCardNumber : '0',
			partId : '0',
			partPartNumber : '0',
			qty : '0',
			remarkMultiple : '0',
			documentStatusId : '0',
			documentStatusName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}